const INITIAL_INVOICE_HISTORY = {
  loading: true,
  error: null,
  result: []
};

export const FETCH_INVOICE_HISTORY_BEGIN = "FETCH_INVOICE_HISTORY_BEGIN";
export const FETCH_INVOICE_HISTORY_FULFILLED =
  "FETCH_INVOICE_HISTORY_FULFILLED";
export const FETCH_INVOICE_HISTORY_REJECTED = "FETCH_INVOICE_HISTORY_REJECTED";

export function invoiceHistoryReducer(
  state = INITIAL_INVOICE_HISTORY,
  action = {}
) {
  switch (action.type) {
    case FETCH_INVOICE_HISTORY_BEGIN: {
      return { ...state, loading: true, error: null };
    }
    case FETCH_INVOICE_HISTORY_FULFILLED: {
      if (action.payload.length > 0) action.payload.reverse();
      return { ...state, loading: false, error: null, result: action.payload };
    }
    case FETCH_INVOICE_HISTORY_REJECTED: {
      return {
        ...state,
        loading: false,
        error: action.payload.error
      };
    }
    default: {
      return { ...state };
    }
  }
}
